import { render, staticRenderFns } from "./Wp_pdd_select.vue?vue&type=template&id=5af38244&scoped=true&"
import script from "./Wp_pdd_select.vue?vue&type=script&lang=js&"
export * from "./Wp_pdd_select.vue?vue&type=script&lang=js&"
import style0 from "./Wp_pdd_select.vue?vue&type=style&index=0&id=5af38244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af38244",
  null
  
)

export default component.exports